import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import CostsRevenuesVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import GlobalStateModule, { MODULE_ID as GLOBAL_MODULE_ID } from '@abaco/portal-global-state/src/modules/global-state';
import EquipmentApi from './api/EquipmentApi';
import WorkerApi from './api/WorkerApi';
import PriceApi from './api/PriceApi';
import EntityApi from './api/EntityApi';
import CostConsumptionApi from './api/CostConsumptionApi';
import CarbonFootprintApi from './api/CarbonFootprintApi';
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import ActivitiesModule from '@abaco/activities-module/src/modules/activities-module';
import DashboardChartsModule from '@abaco/dashboard-module/src/modules/charts';
import PortalGlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";

export const MODULE_ID = "costs_revenues_module";

const rootPath = "/sitiagri-rest-api/api_basic";
const state = new CostsRevenuesVuexModule();

export default class CostsRevenuesModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private eqApi!: EquipmentApi;
    private worApi!: WorkerApi;
    private prApi!: PriceApi;
    private entApi!: EntityApi;
    private ccApi!: CostConsumptionApi;
    private cfApi!: CarbonFootprintApi;

    private router!: VueRouter;
    private http!: HTTPClient;

    readonly vuexModule = state;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if (this.apiCreated) {
            return;
        }

        const EquipmentApi = (await import("./api/EquipmentApi")).default;
        this.eqApi = new EquipmentApi(http, rootPath);

        const WorkerApi = (await import("./api/WorkerApi")).default;
        this.worApi = new WorkerApi(http, rootPath);

        const PriceApi = (await import("./api/PriceApi")).default;
        this.prApi = new PriceApi(http, rootPath);

        const EntityApi = (await import("./api/EntityApi")).default;
        this.entApi = new EntityApi(http, rootPath);

        const CostConsumptionApi = (await import("./api/CostConsumptionApi")).default;
        this.ccApi = new CostConsumptionApi(http);

        const CarbonFootprintApi = (await import("./api/CarbonFootprintApi")).default;
        this.cfApi = new CarbonFootprintApi(http);

        this.apiCreated = true;
    }

    public get equipmentApi(){
        return this.eqApi;
    }
    public get workerApi(){
        return this.worApi;
    }
    public get priceApi(){
        return this.prApi;
    }
    public get entityApi(){
        return this.entApi;
    }
    public get costConsumptionApi(){
        return this.ccApi;
    }
    public get carbonFootprintApi(){
        return this.cfApi;
    }

    dependsOn = {
        [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [ActivitiesModule.MODULE_ID]: () => new ActivitiesModule(),
        [PortalGlobalStateModule.MODULE_ID]: () => new PortalGlobalStateModule(),
    }

}
